export const enWhatsapp = {
    translation : {   
        "Whatsapp": "Whatsapp",
        "Chat con":'Chat with',
    }
};